import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(35.000000, 30.000000)">
        <path
          d="M20.7256 27.6738C20.7256 26.2904 20.2373 25.2324 19.2607 24.5C18.2842 23.7513 16.5264 22.9701 13.9873 22.1562C11.4482 21.3262 9.43815 20.5124 7.95703 19.7148C3.92057 17.5339 1.90234 14.596 1.90234 10.9014C1.90234 8.98079 2.43945 7.27181 3.51367 5.77441C4.60417 4.26074 6.15853 3.08073 8.17676 2.23438C10.2113 1.38802 12.4899 0.964844 15.0127 0.964844C17.5518 0.964844 19.8141 1.42871 21.7998 2.35645C23.7855 3.2679 25.3236 4.56185 26.4141 6.23828C27.5208 7.91471 28.0742 9.81901 28.0742 11.9512H20.75C20.75 10.3236 20.2373 9.06217 19.2119 8.16699C18.1865 7.25553 16.7461 6.7998 14.8906 6.7998C13.1003 6.7998 11.7087 7.18229 10.7158 7.94727C9.72298 8.69596 9.22656 9.6888 9.22656 10.9258C9.22656 12.0814 9.80436 13.0498 10.96 13.8311C12.1318 14.6123 13.849 15.3447 16.1113 16.0283C20.278 17.2816 23.3135 18.8359 25.2178 20.6914C27.1221 22.5469 28.0742 24.8581 28.0742 27.625C28.0742 30.7012 26.9105 33.1182 24.583 34.876C22.2555 36.6175 19.1224 37.4883 15.1836 37.4883C12.4492 37.4883 9.95898 36.9919 7.71289 35.999C5.4668 34.9899 3.74967 33.6146 2.56152 31.873C1.38965 30.1315 0.803711 28.1133 0.803711 25.8184H8.15234C8.15234 29.7409 10.4961 31.7021 15.1836 31.7021C16.9251 31.7021 18.2842 31.3522 19.2607 30.6523C20.2373 29.9362 20.7256 28.9434 20.7256 27.6738Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
